import $ from 'jquery';
import 'slick-carousel';

const testSlider = {
	init() {
		this.slideEls = document.querySelectorAll('.inr-tabs__content');
		this.slideNavEls = document.querySelectorAll('.inr-tabs__titles');

		if (this.slideEls) {
			$(this.slideEls).slick(
				{
					arrows: true,
					dots: false,
					slidesToShow: 1,
					slidesToScroll: 1,
					initialSlide: 0,
					loop: true,
					infinite: true,
					prevArrow: '<button id="prev" class="prev no-button-style"><span class="screen-reader-text">Previous</span><span class="dashicons dashicons-arrow-left-alt"></span><span class="mobile-text"></span></button>',
					nextArrow: '<button id="next" class="next no-button-style"><span class="mobile-text"></span><span class="screen-reader-text">Next</span><span class="dashicons dashicons-arrow-right-alt"></span></button>',
					rows: 0, // Remove extra <div> from slick markup.
				},
			);
		}
		if ($(window).width() <= 768) {
			$(this.slideEls).on(
				'init beforeChange',
				(event, slick, currentSlide, nextSlide) => {
					const nextTitle = $(`.inr - tabs__titles .tab - title[data - id = "${nextSlide}"]`).next().text();
					const prevTitle = $(`.inr - tabs__titles .tab - title[data - id = "${nextSlide}"]`).prev().text();
					$('.inr-tabs__content #next').show();
					$('.inr-tabs__content #prev').show();
					$('.inr-tabs__content .mobile-text').text('');
					if (nextTitle) {
						$('.inr-tabs__content #next .mobile-text').text(nextTitle);
					} else {
						$('.inr-tabs__content #next').hide();
					}

					if (prevTitle) {
						$('.inr-tabs__content #prev .mobile-text').text(prevTitle);
					} else {
						$('.inr-tabs__content #prev').hide();
					}
				},
			);

			const nextTitle = $('.inr-tabs__titles .tab-title[data-id="0"]').next().text();
			const prevTitle = $('.inr-tabs__titles .tab-title[data-id="0"]').prev().text();

			$('.inr-tabs__content #next').show();
			$('.inr-tabs__content #prev').show();
			$('.mobile-text').text('');

			if (nextTitle) {
				$('.inr-tabs__content #next .mobile-text').text(nextTitle);
			} else {
				$('.inr-tabs__content #next').hide();
			}

			if (prevTitle) {
				$('.inr-tabs__content #prev .mobile-text').text(prevTitle);
			} else {
				$('.inr-tabs__content #prev').hide();
			}
		}

		$('.inr-tabs__titles .tab-title[data-id=0]').addClass('active');

		$(this.slideEls).on(
			'init beforeChange',
			(event, slick, currentSlide, nextSlide) => {
				$('.inr-tabs__titles .tab-title').removeClass('active');
				$(`.inr - tabs__titles .tab - title[data - id = "${nextSlide}"]`).addClass('active');
			},
		);

		$('.inr-tabs__titles .tab-title').on(
			'click',
			function () {
				const goToId = $(this).attr('data-id');
				$('.inr-tabs__titles .tab-title').removeClass('active');
				$(this).addClass('active');
				$('.inr-tabs__content').slick('slickGoTo', parseInt(goToId));
			},
		);
	},
};

testSlider.init();
